export default function highlightMatchingString(text: string, query: string) {
  if (!query) return text;

  const words = query.split(/\s+/).filter(Boolean).map(escapeRegExp);

  if (words.length === 0) return text;

  const regex = new RegExp(`(${words.join('|')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} className="bg-yellow-600 p-0">
        {part}
      </mark>
    ) : (
      <span key={index}>{part}</span>
    ),
  );
}

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
